import { UI, HStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box, Checkbox } from 'native-base';
import React from 'react';

export interface AgreementCheckProps {
  onChange: (value: boolean) => void;
  isChecked: boolean;
  unableToUncheck?: boolean;
}

export const AgreementCheck: React.FC<AgreementCheckProps> = ({
  onChange,
  isChecked,
  unableToUncheck,
}) => {
  return (
    <HStack alignItems="center" flex={1} space="stack.nano">
      {unableToUncheck && isChecked ? (
        <Box
          w="inline.xxxs"
          h="stack.xxxs"
          bg="neutral.light"
          alignItems="center"
          justifyContent="center"
          borderRadius={BoxBorder.thick}>
          <Box w="inline.nano" h="2px" bg="neutral.white" />
        </Box>
      ) : (
        <Checkbox
          onChange={onChange}
          value="1"
          isChecked={isChecked}
          _checked={{
            borderColor: 'brand.primary.principal',
            backgroundColor: 'brand.primary.principal',
          }}
          _hover={{ borderColor: 'brand.primary.principal' }}
        />
      )}
      <UI.Text flex={1}>
        Declaro que esta ordem foi previamente solicitada pelo cliente, via canal oficial e dentro
        da validade da data, com registro disponível para consulta e auditoria.
      </UI.Text>
    </HStack>
  );
};
